import * as path from 'path';
import { Exercise } from '../../entities';
import { IWorkoutSelectionManager } from '../../logic';
import { removeExtention } from '../files';

export const voiceTipModelsInCorrectOrder = ['Katie', 'Dave', 'Migisha', 'Amy', 'Audrina', 'Tyson', 'Alrieta', 'Eliza'];

export interface IVoiceTipMetaData {
  exerciseReferenceNr: string;
  status: 'NotDone' | 'Pass' | 'Fail';
  model: string;
  isTechniqueTip: boolean;
}

export async function mapMetaDataToResponse(
  workoutSelection: IWorkoutSelectionManager,
  metaData: any, mapExercise = false, voiceTipsMetaData: IVoiceTipMetaData[],
) {
  let exercise: Exercise | undefined;
  if (mapExercise) {
    try {
      exercise = await workoutSelection.getExercise(removeExtention(metaData.name));
    } catch (err) {
      // ignored and continue
    }
  }

  const voiceTipStatusses = exercise != null ? getVoiceTipStatusArray(voiceTipsMetaData, exercise) : [];

  return {
    name: removeExtention(metaData.name),
    contentType: metaData.contentType,
    size: metaData.size,
    createdAtDate: metaData.timeCreated,
    updatedAtDate: metaData.updated,
    extension: path.extname(metaData.name),
    exercise,
    voiceTipStatusses,
    metadata: metaData.metadata,
    numberOfOccurancesInWorkouts:
    exercise != null && exercise.numberOfOccurances != null ? exercise.numberOfOccurances : 0,
  };
}

export async function mapMetaDataToResponseForReviewFromFiles(
  workoutSelectionManager: IWorkoutSelectionManager,
  metaData: any,
  mapExercise = false,
  allowEditAndDetails: boolean,
) {
  // TODO: try and merge this with mapMetaDataToResponse above, which is used in some
  // of the review tool responses, but not all
  let exercise;
  if (mapExercise) {
    try {
      exercise = await workoutSelectionManager.getExercise(removeExtention(metaData.name));
      if (exercise && !allowEditAndDetails) {
        // only necessary fields if details not allowed
        exercise = {
          uniqueReferenceNumber: exercise.uniqueReferenceNumber,
          tipVerbalInstruction: exercise.tipVerbalInstruction,
          name: exercise.name,
        };
      }
    } catch (err) {
      // ignored and continue
    }
  }
  return {
    name: removeExtention(metaData.name),
    contentType: metaData.contentType,
    size: metaData.size,
    createdAtDate: metaData.timeCreated,
    updatedAtDate: metaData.updated,
    extension: path.extname(metaData.name),
    exercise,
    metadata: metaData.metadata,
  };
}

export function mapVoiceTipMetaDataToResponse(metaData: any | undefined): IVoiceTipMetaData {
  if (metaData == null || metaData.name == null) {
    throw Error('No metadata');
  }

  const fileNameWithoutExtention = removeExtention(metaData.name);
  const split = fileNameWithoutExtention.split('_');
  let exerciseReferenceNr = `None`;
  if (split.length > 0) {
    exerciseReferenceNr = split[0];
  }

  let model = `None`;
  let isTechniqueTip = false;
  if (split.length > 1) {
    model = split[1];
  }

  if (split.length > 2 && split[1] === 'technique') {
    model = split[2];
    isTechniqueTip = true;
  }
  return {
    exerciseReferenceNr,
    status:
    metaData.metadata != null ? metaData.metadata.status : 'NotDone',
    model,
    isTechniqueTip,
  };
}

function getVoiceTipStatusArray(voiceTipsMetaData: IVoiceTipMetaData[], exercise: Exercise) {
  const voiceTipStatusses = [...voiceTipModelsInCorrectOrder];
  const techniqueTipStatusses = [...voiceTipModelsInCorrectOrder];
  const exsNumberForcedToString =  exercise.uniqueReferenceNumber.toString();
  for (const voiceTipModel of voiceTipModelsInCorrectOrder) {
    const metaDataForExerciseAndModel = voiceTipsMetaData.find(
      (metaData) =>
      metaData.model === voiceTipModel
      &&
      metaData.exerciseReferenceNr === exsNumberForcedToString && !metaData.isTechniqueTip);
    const techniqueTipMetaDataForExerciseAndModel = voiceTipsMetaData.find(
      (metaData) =>
      metaData.model === voiceTipModel
      &&
      metaData.exerciseReferenceNr === exsNumberForcedToString && metaData.isTechniqueTip);

    const indexOfModelInArrayVoiceTip = voiceTipModelsInCorrectOrder.indexOf(voiceTipModel);
    if (metaDataForExerciseAndModel != null && metaDataForExerciseAndModel.status != null) {
      voiceTipStatusses[indexOfModelInArrayVoiceTip] = metaDataForExerciseAndModel.status;
    } else {
      voiceTipStatusses[indexOfModelInArrayVoiceTip] = '';
    }

    const indexOfModelInArrayTechniqueTip = voiceTipModelsInCorrectOrder.indexOf(voiceTipModel);
    if (techniqueTipMetaDataForExerciseAndModel != null && techniqueTipMetaDataForExerciseAndModel.status != null) {
      techniqueTipStatusses[indexOfModelInArrayTechniqueTip] = techniqueTipMetaDataForExerciseAndModel.status;
    } else {
      techniqueTipStatusses[indexOfModelInArrayTechniqueTip] = '';
    }
  }
  return [...voiceTipStatusses, ...techniqueTipStatusses];
}
